// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoDataRow_noData__B_giz","no_data_text":"NoDataRow_no_data_text__yrwmS","wrapper":"NoDataRow_wrapper__tXB_u","mainText":"NoDataRow_mainText__LMutm"};